import { useState, useEffect } from "react";
import "./../../../styles/vendors/weatherIcons.min.css";
import "./../../../styles/utilities/weather-icons.min.css";

const Weather = () => {
  const [weather, setWeather] = useState("--");
  const [icon, setIcon] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const delay = 1 * 60 * 60 * 1000; // 1 hour

    const fetchWeatherData = async () => {
      try {
        setIsLoading(true);

        // Use the proxy endpoint
        const response = await fetch("/api/weather");
        const data = await response.json();

        if (response.ok) {
          setWeather(data.temperature);
          setIcon(data.icon);
        } else {
          console.error("Error fetching weather data:", data.error);
        }
      } catch (error) {
        console.error("Error fetching weather data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // Immediately fetch weather data
    fetchWeatherData();

    // Set up interval for regular updates
    const interval = setInterval(() => {
      fetchWeatherData();
    }, delay);

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="weather up">
      <span className={`wi ${icon}`}></span> {isLoading ? "--º" : `${weather}º`}
    </div>
  );
};

export default Weather;
